import { render, staticRenderFns } from "./MyCourseDetail.vue?vue&type=template&id=e4ce4342&scoped=true"
import script from "./MyCourseDetail.vue?vue&type=script&lang=ts"
export * from "./MyCourseDetail.vue?vue&type=script&lang=ts"
import style0 from "./MyCourseDetail.vue?vue&type=style&index=0&id=e4ce4342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ce4342",
  null
  
)

export default component.exports